import Mock from '../mock'
let userData = JSON.parse(localStorage.getItem('UserInfo'))

const userList = [
    {
        id: 1,
        role: 'SA',
        name: 'SUPERADMIN 1',
        username: 'jason_alexander',
        email: 'jason@ui-lib.com',
        avatar: '',
        age: 25,
    },
    // {
    //     id: 1,
    //     role: 'SA',
    //     name: `${userData[0]} ` || 'Jason Alexanderm',
    //     username: 'jason_alexander',
    //     email: 'jason@ui-lib.com',
    //     avatar: `${userData[1]} ` || '/assets/images/face-6.jpgs',
    //     age: 25,
    // },
]

Mock.onPost('/api/auth/login').reply(async (config) => {
    try {
        const { email } = JSON.parse(config.data)
        const user = userList.find((u) => u.email === email)

        if (!user) return [400, { message: 'Invalid email or password' }]

        const payload = { user: userList[0] }
        return [200, payload]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Internal server error' }]
    }
})

Mock.onPost('/api/auth/register').reply((config) => {
    try {
        const { email, username } = JSON.parse(config.data)
        const user = userList.find((u) => u.email === email)

        if (user) return [400, { message: 'User already exists!' }]

        const newUser = {
            id: 2,
            role: 'GUEST',
            name: 'Unknown',
            age: 25,
            email: email,
            username: username,
            avatar: '/assets/images/face-6.jpg',
        }

        userList.push(newUser)

        const payload = { user: { ...newUser } }
        return [200, payload]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Internal server error' }]
    }
})

Mock.onGet('/api/auth/profile').reply((config) => {
    try {
        const payload = { user: userList[0] }
        return [200, payload]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Internal server error' }]
    }
})
